import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

import axios from "../../helpers/axios";
import {
  CardPaginator,
  GeneralTable,
  Layout,
  Notification,
  ScreenHeading,
} from "../../webtracking/components";

import InvoiceRowActions from "../components/InvoiceRowActions";

const useInvoicesScreen = () => {
  const [message, setMessage] = useState("");

  const [pages, setPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const [isLoading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [search, setSearch] = useState("")

  const cols = [
    {
      label: "Factura",
      render: (row) => row.name,
    },
    {
      label: "Status",
      render: (row) => <span className="tag">{row.status}</span>,
    },
    {
      label: "Creación",
      render: (row) => (
        <span title={row.created_at}>{row.created_at.substring(0, 10)}</span>
      ),
    },
    {
      label: "Aciones",
      className: "has-text-right",
      render: (row) => (
        <div style={{ float: "right" }}>
          <InvoiceRowActions invoice={row} onDelete={() => handleDelete(row)} />
        </div>
      ),
    },
  ];

  const loadInvoices = (currentPage) => {
    const pageSize = 50;

    axios
      .get(`/api/invoices/?search=${search}&offset=${currentPage * pageSize}&limit=${pageSize}`)
      .then(({ data }) => {
        setPages(Math.ceil(data.count / pageSize));
        setInvoices(data.results);
      })
      .catch(() => setMessage("No se pudieron cargar las facturas"))
      .then(() => setLoading(false));
  };

  const handleDelete = (invoice) => {
    const confirmation = window.confirm(
      "¿Esta seguro que desea eliminar esta factura?"
    );

    if (!confirmation) {
      return;
    }

    axios
      .delete(`/api/invoices/${invoice.id}/`)
      .then(() => {
        loadInvoices(currentPage);
      })
      .catch(() => {
        setMessage("No se pudo borrar el recurso");
      });
  };

  useEffect(() => {
    setLoading(true);
    setInvoices([]);
    loadInvoices(currentPage);
  }, [currentPage, search]);

  return {
    isLoading,
    invoices,
    cols,
    message,
    pages,
    currentPage,
    setCurrentPage,
    search,
    setSearch
  };
};

const InvoicesScreen = () => {
  const {
    isLoading,
    invoices,
    cols,
    message,
    pages,
    currentPage,
    setCurrentPage,
    search,
    setSearch
  } = useInvoicesScreen();

  return (
    <Layout>


      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <ScreenHeading title="Facturas" />
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <div className="control has-icons-left">
              <input
                type="text"
                className="input is-rounded is-medium"
                value={search}
                onChange={(event) => {
                  setCurrentPage(0);
                  setSearch(event.target.value);
                }}
                placeholder="Buscar por nombre"
              />
              <span className="icon is-left">
                <FontAwesomeIcon icon={["fas", "search"]} />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="container has-background-light p-6 mt-5">
        <Notification message={message} />

        <div className="card mb-5 py-3 px-3">
          <div className="level">
            <div className="level-left">
              <div className="field">
                <div className="control">
                  <Link to="/invoices/create" className="button is-primary">
                    Cargar Factura
                  </Link>
                </div>
              </div>
            </div>
            <div className="level-right">
              <CardPaginator
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pages={pages}
              />
            </div>
          </div>
        </div>
        <GeneralTable
          rowKey="id"
          isLoading={isLoading}
          rows={invoices}
          cols={cols}
        />
    </div>
  </Layout>
  );
};

export default InvoicesScreen;
